import React, {useState} from 'react';
import jsPDF from "jspdf";
import * as htmlToImage from "html-to-image";
import { useGlobalSpinnerActionsContext } from "../context/GlobalSpinnerContext";


export const downloadSurveyPDF = async(setGlobalSpinner) => {
  setGlobalSpinner(true)
  const doc = new jsPDF("p", "px", "a4"); // (1)
  let elements = ['form']
 
  await creatPdf({ doc, elements }); // (3-5)

  doc.save(`patient_summary.pdf`);
  setGlobalSpinner(false)
}

async function creatPdf({ doc, elements }) {
  let top = 15;
  const padding = 10;
  let margin = "20";
  // const urls = localStorage.getItem("stringDataUrl")
  let dataUrlArr = [];
  let header = document.querySelector('.summary-header');
  if(header.classList.contains('hide')){
    header.classList.remove("hide");
  }

  // dataUrlArr.unshift(firstPage)
  let retArray = [...elements];
  for (let i = 0; i < retArray.length; i++) {
    // el.style.backgroundColor = "White"
    let el = document.getElementById(retArray[i]);

    let imgData = await htmlToImage.toJpeg(el, {
        backgroundColor: "#FFFFFF",
        quality: 3,
      });
    
    // let imgData = retArray[i]
    let elHeight = el.offsetHeight;
    let elWidth = el.offsetWidth; // hardcoding this value to get perfect preview for screen width 100% 
    const pageWidth = doc.internal.pageSize.getWidth();
    if (elWidth > pageWidth) {
      const ratio = pageWidth / elWidth;
      elHeight = elHeight * ratio - padding;
      elWidth = elWidth * ratio - padding;
    }
    const pageHeight = doc.internal.pageSize.getHeight();
    doc.addImage(imgData, "JPEG", padding, top, elWidth, elHeight, `image${i}`);
    top += elHeight;
    let heightLeft = elHeight - pageHeight;
    let calCulatedHeight;
    let testHight = 0;
    let repeatedHeight = 0;
      while (heightLeft >= 0) {
        testHight += pageHeight;
        repeatedHeight += 40; // if image cut adjust this value
        let maniPulatedHeight = testHight - repeatedHeight; //
        calCulatedHeight = elHeight - testHight;
        const whiteDiv = document.createElement("div");
        whiteDiv.style.backgroundColor = "#FFFFFF"; // Use white color
        whiteDiv.style.width = "200px"; // Adjust to your desired width
        whiteDiv.style.height = "100px"; // Adjust to your desired height
        // let position = heightLeft - elHeight;
        doc.addPage();
        document.body.appendChild(whiteDiv);
        const whiteDataUrl = await htmlToImage.toJpeg(
          whiteDiv,
          "JPEG",
          padding,
          40,
          elWidth,
          elHeight,
          `image${i}`
        );
        // Add the white space to the PDF using doc.addImage

        doc.addImage(
          imgData,
          "JPEG",
          padding,
          -maniPulatedHeight,
          elWidth,
          elHeight,
          `image${i}`
        );
        doc.addImage(whiteDataUrl, "JPEG", 0, 0, elWidth, 15, `image`); // Adjust the coordinates and size as
        heightLeft -= pageHeight - 100;
        // elHeight = elHeight - pageHeight
      }
  }

  header.classList.add("hide");
}
